import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class Agreements {
	async getAll(pgid: PGSchema.pages["id"], params?: { uid?: string; status?: string }, token?: string) {
		return xget<{ items: PGSchema.hcm_agreements[] }>(`/pages/${pgid}/agreements`, params, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async getOne(pgid: PGSchema.pages["id"], id: string, token?: string) {
		return xget<PGSchema.hcm_agreements>(`/pages/${pgid}/agreements/${id}`, undefined, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async create(
		pgid: PGSchema.pages["id"],
		data: Omit<PGSchema.hcm_agreements, "id" | "created_at" | "updated_at" | "pgid"> & {
			/** Se persiste en el mismo POST que el contrato (`payroll_items` en el cuerpo). */
			payroll_items?: { concept_id: string; override_value?: number | null; active?: boolean }[];
		},
		token?: string
	) {
		return xhttp<PGSchema.hcm_agreements>(`/pages/${pgid}/agreements`, "POST", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async update(pgid: PGSchema.pages["id"], id: string, data: Partial<Omit<PGSchema.hcm_agreements, "id" | "created_at" | "updated_at" | "pgid">>, token?: string) {
		return xhttp<PGSchema.hcm_agreements>(`/pages/${pgid}/agreements/${id}`, "PUT", data, {
			headers: token ? { "app-token": token } : undefined
		});
	}

	async delete(pgid: PGSchema.pages["id"], id: string, token?: string) {
		return xhttp<{ deleted: boolean }>(
			`/pages/${pgid}/agreements/${id}`,
			"DELETE",
			{},
			{
				headers: token ? { "app-token": token } : undefined
			}
		);
	}
}
